import BackNavigationArrow from "@/components/views/BackNavigationArrow";
import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { setErrorsToForm } from "@/utils/formUtils";
import { Card, Form } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router";
import { useCreateClient } from "../../../common/api/queries";
import { ClientFormBody } from "../components/forms/ClientFormBody";
import { useClientSearch } from "../hooks";
import { CLIENT_ROUTE_PATHS } from "../paths";
import { CreateUpdateClient } from "../types";

export const ClientCreateContainer = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [form] = Form.useForm<CreateUpdateClient>();

  const createClient = useCreateClient();

  const clientSearch = useClientSearch();

  useEffect(() => {
    return () => {
      clientSearch.onResultDelete();
    };
  }, []);

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={
          <BackNavigationArrow>
            <h2>{t("client.titles.create")}</h2>
          </BackNavigationArrow>
        }
      >
        <Form form={form} layout="vertical" name="createClientForm">
          <ClientFormBody
            form={form}
            viewType="form"
            clientSearch={clientSearch}
            onFormSubmit={(data) =>
              createClient.mutate(data, {
                onSuccess: (data) =>
                  navigate(generatePath(CLIENT_ROUTE_PATHS.detail.to, { id: data.id }), { replace: true }),
                onError: (error) => setErrorsToForm(form, "client.attrs", error.violations),
              })
            }
            isCreatingNewClient={true}
          />
        </Form>
      </Card>
    </ContentWrapper>
  );
};
